export const BEHAVIOR_FACTOR_TYPES = {
  BEHAVIOR_FACTOR: 'BEHAVIOR_FACTOR',
  BEHAVIOR_SUBFACTOR: 'BEHAVIOR_SUBFACTOR',
} as const;
